import { COOKIES } from "constants/cookies";
import { getCookie } from "services/cookies";

const INITIAL_CHECKOUT_DATA_STATE = {
  isLoading: false,
  checkoutData: {
    billing_address: {
      first_name: "",
      last_name: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipcode: "",
      country: ""
    },
    cards: [],
    subtotal: 0,
    tax: 0,
    total: 0,
    total_savings: 0
  },
  selectedPayment: () => null,
  disableSubmitPayment: () => null,
  getCheckoutData: async () => null,
  setPayment: () => null,
  setDisableSubmitPayment: () => null,
  handleOrderFailure: () => null,
  handleCheckout: async () => null
};

const INITIAL_CHECKOUT_PAYMENT_STATE = {
  isLoading: false,
  isDdOpen: false,
  isFormOpen: false,
  paymentData: {},
  paymentSaving: false,
  paymentMethodErrorMessage: null,
  getPaymentData: async () => null,
  openDropDown: () => null,
  toggleForm: () => null,
  submitPaymentMethod: async () => null,
  setPaymentMethodErrorMessage: () => null
};

export const INITIAL_DEVICE_STATE = {
  user_agent: navigator.userAgent,
  session_id: getCookie(COOKIES.X_SESSION),
  device_id: getCookie(COOKIES.VDCK2)
};

export const INITIAL_CHECKOUT_CONTEXT_STATE = {
  ...INITIAL_CHECKOUT_DATA_STATE,
  ...INITIAL_CHECKOUT_PAYMENT_STATE,
  device: INITIAL_DEVICE_STATE,
  couponApplied: "",
  setCouponApplied: () => null
};

export const FEEDBACK_MESSAGES = {
  TIMEOUT: "Checkout failed because of timeout. Please try again.",
  CHECKOUT_FETCH_ERROR: "An error occurred while fetching data.",
  CHECKOUT_ERROR: "An error occurred while checking out.",
  PAYMENT_FETCH_ERROR: "Error fetching payment data.",
  SAVE_PAYMENT_SERVER_ERROR: "Cannot save payment method on server.",
  SAVE_PAYMENT_DEFAULT_ERROR: "An error occurred while saving payment method.",
  BILLING_ADDRESS_INCOMPLETE_ERROR: "Please complete the Billing Address form.",
  INCOMPLETE_NAME_ERROR: "Please enter Cardholder's full name.",
  INVALID_ADDRESS_ERROR: "Please check your address and try again."
};

export const STRIPE_APPEARANCE = {
  theme: "stripe",
  rules: {
    ".Tab": {
      border: "none"
    }
  }
};

export const STRIPE_FORM_ADDRESS_OPTIONS = {
  mode: "billing",
  allowedCountries: ["US"],
  defaultValues: {
    address: {
      state: "CA"
    }
  },
  fields: {
    line1: "always",
    city: "always",
    state: "always",
    postal_code: "always",
    country: "always"
  }
};
